import { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { nets, tinyFaceDetector } from 'face-api.js';
import { message, Modal, Popover, Progress } from 'antd';
import Webcam from 'react-webcam';
import { isEmpty } from 'lodash';
import * as faceapi from 'face-api.js';
import routes from 'Routes';
import Config from 'Services/Config';
import { getOS } from 'Utilities/utils';
import Header from '../WebScreens/Header';
import logo from '../../../Assets/logo.png';
import authService from 'Services/authService';
import useDeviceDetect from 'Hooks/useDeviceDetect';
import Wrong from '../../../Assets/images/close.svg';
import Right from '../../../Assets/images/right1.svg';
import circle from '../../../Assets/images/Ellipse.svg';
import { usePersistedStore } from 'Store/persistedStore';
import dots from '../../../Assets/images/count-down-dots.svg';
import Camera from '../../../Assets/images/camera_capture.svg';
import start_count_bg from '../../../Assets/images/start_count_bg.svg';
import { getFileFromBase64 } from 'Utilities/componentSpecificUtilities';
import { useLayoutStore } from 'Store/LayoutStore';
import AITestRecording from './AITestRecording';

nets.tinyFaceDetector.loadFromUri(`${process.env.PUBLIC_URL}/models`);

// speed
// const imageAddr =
//   'https://4k-uhd.nl/wp-content/uploads/2018/08/4K-3840x2160-Wallpaper-Uitzicht-5.jpg';

const imageAddr = Config.API_URL + 'static/logos/load_test.jpg';
const downloadSize = 2411725; //bytes

const AITestScreen = (props) => {
  const { isDarkMode, setDarkMode } = useLayoutStore();
  let isTestingMic = false;
  const [startCount, setStartCount] = useState(3);
  const [isWebStart, setWebStartScreen] = useState();
  const [isLowLight, setLowLight] = useState(false);
  const [isMicGood, setMicGood] = useState(false);
  const [isStart, setStartInterviewScreen] = useState(false);
  const [isNetSpeedGood, setNetSpeedGood] = useState(false);
  const [liveSnap, setLiveSnap] = useState();
  const [faces, setFaces] = useState([]);
  const [faceThreshold, setFaceThreshold] = useState(0);
  const systemOS = getOS();
  const [isLive, setIsLive] = useState(false);
  const isBlinkingRef = useRef(false);
  const params = useParams();
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const isMobileDevice = useDeviceDetect();
  const [messageApi, contextHolder] = message.useMessage();
  const { resetSkippedQuestions, setCapturedata } = usePersistedStore();
  const [isDetectionStarted, setDetectionStarted] = useState(false);
  const [isRecordingOpen, setRecordingModalOpen] = useState(false);
  const [isVideoStreamOK, setVideoStreamTest] = useState(false);
  //  mic
  const audioContext = new (window.AudioContext ||
    window.webkitAudioContext)();
  const analyser = audioContext.createAnalyser();

  const checkLowLight = async () => {
    const video = videoRef?.current?.video;

    if (!video) return;

    // Detect face in the video
    const detection = await faceapi
      .detectSingleFace(video, new faceapi.SsdMobilenetv1Options())
      .withFaceLandmarks();

    if (!detection || !detection.box) {
      console.log('No face detected or no bounding box.');
      return;
    }

    console.log(detection, 'detectdetection?.boxion', detection?.box);
    if (detection && detection?.box) {
      // Get face bounding box
      const { x, y, width, height } = detection.box;

      // Get canvas context
      const canvasContext = videoRef?.current
        ?.getCanvas()
        ?.getContext('2d');

      if (!canvasContext) return;

      // Draw the video frame on canvas
      const currentWidth = video.clientWidth;
      const currentHeight = video.clientHeight;
      canvasContext.drawImage(video, 0, 0, currentWidth, currentHeight);

      // Get only the face region
      const imageData = canvasContext.getImageData(
        x,
        y,
        width,
        height,
      ).data;

      let totalBrightness = 0;

      // Calculate brightness in the face region
      for (let i = 0; i < imageData.length; i += 4) {
        const r = imageData[i];
        const g = imageData[i + 1];
        const b = imageData[i + 2];
        const brightness = 0.2126 * r + 0.7152 * g + 0.0722 * b; // Luminance formula
        totalBrightness += brightness;
      }

      const avgBrightness = totalBrightness / (width * height);

      // Set a threshold for low-light detection
      const lowLightThreshold = 30;

      if (avgBrightness < lowLightThreshold) {
        console.log('Face is in low light.');
        setLowLight(false);
      } else {
        console.log('Face lighting is sufficient.');
        setLowLight(true);
      }
    }
  };

  // const checkLowLight = () => {
  //   const video = videoRef?.current?.video;

  //   const canvasContext = videoRef?.current?.getCanvas()?.getContext('2d');

  //   const currentWidth = videoRef?.current?.video?.clientWidth;
  //   const currentHeight = videoRef?.current?.video?.clientHeight;

  //   canvasContext?.drawImage(video, 0, 0, currentWidth, currentHeight);
  //   const imageData = canvasContext?.getImageData(
  //     0,
  //     0,
  //     currentWidth,
  //     currentHeight,
  //   ).data;

  //   let totalBrightness = 0;

  //   for (let i = 0; i < imageData?.length; i += 4) {
  //     const r = imageData[i];
  //     const g = imageData[i + 1];
  //     const b = imageData[i + 2];
  //     const brightness = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  //     // const brightness = (r + g + b)/3;
  //     totalBrightness += brightness;
  //   }

  //   const avgBrightness = totalBrightness / (currentWidth * currentHeight);

  //   const lowLightThreshold = 30;

  //   if (avgBrightness < lowLightThreshold) {
  //     setLowLight(true);
  //   } else {
  //     setLowLight(false);
  //   }
  // };

  // useEffect(() => {
  //   const loadModels = async () => {
  //     await faceapi.nets.ssdMobilenetv1.loadFromUri('/models');
  //     await faceapi.nets.faceLandmark68Net.loadFromUri('/models');
  //     await faceapi.nets.faceRecognitionNet.loadFromUri('/models');
  //   };

  //   loadModels();
  // }, []);

  useEffect(() => {
    let id = setInterval(async () => {
      if (!videoRef?.current?.video) return; // Stop if already verified as live

      // Step 1: Detect Face
      const detections = await faceapi
        .detectAllFaces(
          videoRef.current.video,
          new faceapi.TinyFaceDetectorOptions(),
        )
        .withFaceLandmarks();
      setFaces(detections);
      if (detections.length === 1) {
        const face = detections[0];
        const boxArea = Math.floor(face.detection.box.area);
        const frameHeight = videoRef?.current?.video?.clientHeight || 1;
        const frameWidth = videoRef?.current?.video?.clientWidth || 1;
        const frameArea = frameHeight * frameWidth;
        const detectedFaceThreshold = Math.min(
          Math.floor((boxArea / frameArea) * 100),
          100,
        );
        setFaceThreshold(detectedFaceThreshold);

        // Step 2: Detect Blink
        if (!isLive) {
          detectBlink(face.landmarks);
        }
      } else {
        setFaceThreshold(0);
      }
    }, 1000);

    return () => clearInterval(id);
  }, [videoRef, isLive]);

  const detectBlink = (landmarks) => {
    const leftEye = landmarks.getLeftEye();
    const rightEye = landmarks.getRightEye();

    const avgEAR = (calculateEAR(leftEye) + calculateEAR(rightEye)) / 2;
    if (avgEAR < 0.28 && !isBlinkingRef.current) {
      isBlinkingRef.current = true;
    } else if (avgEAR > 0.27 && isBlinkingRef.current) {
      setIsLive(true);
    }
  };
  // Helper Function: Euclidean Distance
  const euclideanDistance = (p1, p2) =>
    Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));

  // Helper Function: Calculate EAR
  const calculateEAR = (eye) => {
    const vertical1 = euclideanDistance(eye[1], eye[5]);
    const vertical2 = euclideanDistance(eye[2], eye[4]);
    const horizontal = euclideanDistance(eye[0], eye[3]);
    return (vertical1 + vertical2) / (2.0 * horizontal);
  };

  console.log(isLive, 'isLiveisLiveisLiveisLive');
  // useEffect(() => {
  //   let id = setInterval(async () => {
  //     const detections = await tinyFaceDetector(videoRef?.current?.video);
  //     setFaces(detections);

  //     if (detections?.length === 1) {
  //       const boxArea = Math.floor(detections[0].box.area);

  //       const frameHeight = videoRef?.current?.video?.clientHeight;
  //       const frameWidth = videoRef?.current?.video?.clientWidth;

  //       const frameArea = frameHeight * frameWidth;
  //       console.log(boxArea, 'boxArea', frameArea);
  //       const detectedFaceThreshold = Math.floor(
  //         (boxArea / frameArea) * 100,
  //       );
  //       console.log(detectedFaceThreshold, 'detectedFaceThreshold');
  //       setFaceThreshold(detectedFaceThreshold);
  //     } else {
  //       setFaceThreshold(0);
  //     }
  //     // checkLowLight();
  //   }, 500);

  //   return () => {
  //     clearInterval(id);
  //   };
  // }, []);

  const stopWebcam = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
    }
    if (audioContext.state === 'running') {
      audioContext.close();
    }
  };

  useEffect(() => {
    checkRequirements();
    resetSkippedQuestions();
    return () => {
      stopWebcam();
    };
  }, []);

  // const getDeviceName = () => {
  //   const devname = navigator.userAgent;
  //   console.log("devname", devname);
  //   console.log("l", navigator.language);
  //   console.log("av", navigator.appVersion);
  //   console.log("p", navigator.userAgent.match(/^[^(]+\((\w+)/));

  //   console.log("devicedata deviceDetect", deviceDetect());
  //   console.log("devicedata browserName", mobileModel);
  // };

  const startCamera = (constraints) => {
    console.log(constraints, 'constraintsconstraints');
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        streamRef.current = stream;
        videoRef.current.srcObject = stream;
        console.log('Dispatched: ', stream);
      })
      .catch((err) => {
        console.error('error:', err);

        if (err === ' DOMException: Permission denied') {
          console.error('error:', err);
          messageApi.open({
            type: 'error',
            content: 'Error Accessing Camera: ' + err,
          });
          messageApi.open({
            type: 'error',
            content:
              'Camera Permission Denied. Please allow Camera Permission.',
          });
        }
      });
  };

  const stopMicTest = () => {
    isTestingMic = false;
    messageApi.open({
      type: 'success',
      content: 'Mic. is Accessible.',
    });
    setMicGood(true);
  };

  // mic Test.
  const startMicTest = () => {
    setMicGood(false);
    if (isTestingMic) {
      return;
    }
    isTestingMic = true;

    navigator.mediaDevices
      .getUserMedia({
        audio: {
          echoCancellation: { exact: true },
        },
      })
      .then((stream) => {
        setTimeout(stopMicTest, 5000);
        const source = audioContext.createMediaStreamSource(stream);
        source.connect(analyser);
        analyser.connect(audioContext.destination);
      })
      .catch((err) => {
        isTestingMic = false;
        setMicGood(false);
      });
  };

  const showResults = (startTime, endTime) => {
    const duration = (endTime - startTime) / 1000;
    const bitsLoaded = downloadSize * 8;
    const speedBps = (bitsLoaded / duration).toFixed(2);
    const speedKbps = (speedBps / 1024).toFixed(2);
    const speedMbps = (speedKbps / 1024).toFixed(2);

    if (speedKbps < 265) {
      setNetSpeedGood(false);
      messageApi.open({
        type: 'error',
        content:
          'Current Internet Connection is Unsupported. Please Change to Proceed.',
        duration: 60,
      });
    } else {
      setNetSpeedGood(true);
    }
  };

  const measureConnectionSpeed = () => {
    let endTime;
    let download = new Image();
    const startTime = new Date().getTime();

    download.onload = function () {
      endTime = new Date().getTime();
      showResults(startTime, endTime);
    };

    download.onerror = function (err, msg) {
      setNetSpeedGood(false);
    };

    let cacheBuster = '?nnn=' + startTime;
    download.src = imageAddr + cacheBuster;
  };

  const checkRequirements = async () => {
    startCamera({
      audio: true,
      video: true,
    });
    startMicTest();
    await measureConnectionSpeed();
    // getDeviceName();
  };

  const multipleFacesDetected = faces?.length > 1;
  console.log(faceThreshold, 'faceThreshold', faces?.length);
  const invalidCaptureConditions =
    faces?.length !== 1 || faceThreshold < 30;

  const isDisabled = () => {
    if (
      invalidCaptureConditions ||
      isLowLight === false ||
      liveSnap == null ||
      isMicGood === false ||
      isNetSpeedGood === false
      //  ||
      // isVideoStreamOK === false
    ) {
      return true;
    } else {
      return false;
    }
  };

  const progressColorType = faceThreshold < 30 ? '#EA1A1A' : '#4BB543';

  const startMobileInterview = () => {
    if (invalidCaptureConditions) {
      messageApi.open({
        type: 'error',
        content: 'Please keep your face centered and sturdy enough.',
      });
      return;
    }
    if (!isLowLight) {
      messageApi.open({
        type: 'error',
        content: 'Light Conditions are Unsuitable.',
      });
      return;
    }
    if (isMicGood) {
      if (liveSnap != null) {
        setStartInterviewScreen(true);
        startCountAndInterview();
      } else {
        messageApi.open({
          type: 'error',
          content: 'Please Capture your Picture',
        });
      }
    } else {
      messageApi.open({
        type: 'error',
        content: 'Please Allow the Mic Permission',
      });
    }
  };

  const startWebInterview = () => {
    if (invalidCaptureConditions) {
      messageApi.open({
        type: 'error',
        content: 'Please keep your face centered and sturdy enough.',
      });
      return;
    }
    if (!isLowLight) {
      messageApi.open({
        type: 'error',
        content: 'Light Conditions are Unsuitable.',
      });
      return;
    }
    if (isMicGood) {
      if (liveSnap != null) {
        setWebStartScreen(true);
        startCountAndInterview();
      } else {
        messageApi.open({
          type: 'error',
          content: 'Please Capture your Picture',
        });
      }
    } else {
      messageApi.open({
        type: 'error',
        content: 'Please Allow the Mic Permission',
      });
    }
  };

  const startCountAndInterview = () => {
    setInterval(() => {
      setStartCount((prev) => {
        if (prev === 1) {
          props.nextScreen('questionScreen');
          navigate(`${routes.AI_VIDEO_INTERVIEW}/${params.token}/`);
        }
        if (prev !== 1) {
          return prev - 1;
        }
      });
    }, 1000);
  };

  const sendSnap = async (image) => {
    try {
      await authService.sendLiveSnap(image, params.token);
      setDetectionStarted(false);
      await messageApi.open({
        type: 'success',
        content: 'Successfully Captured',
      });
    } catch (error) {
      console.log('Uploading Error: ', error);
    }
  };

  const capture = () => {
    if (invalidCaptureConditions) return;
    setDetectionStarted(true);
    window.requestAnimationFrame(async () => {
      const detections = await tinyFaceDetector(
        videoRef.current.getCanvas(),
      );
      if (detections?.length > 1) {
        await messageApi.open({
          type: 'error',
          content: 'Multiface Detected',
        });
      } else {
        // Detect face and extract embedding
        const detection = await faceapi
          .detectSingleFace(
            videoRef.current.getCanvas(),
            new faceapi.SsdMobilenetv1Options(),
          )
          .withFaceLandmarks()
          .withFaceDescriptor();

        if (detection?.detection?.box) {
          // Get face bounding box
          const { x, y, width, height } = detection?.detection?.box;
          // Get canvas context
          const canvasContext = videoRef?.current
            ?.getCanvas()
            ?.getContext('2d');
          if (!canvasContext) return;
          // Draw the video frame on canvas
          const currentWidth = videoRef?.current?.video.clientWidth;
          const currentHeight = videoRef?.current?.video.clientHeight;
          canvasContext.drawImage(
            videoRef.current.getCanvas(),
            0,
            0,
            currentWidth,
            currentHeight,
          );
          // Get only the face region
          const imageData = canvasContext.getImageData(
            x,
            y,
            width,
            height,
          ).data;
          let totalBrightness = 0;
          // Calculate brightness in the face region
          for (let i = 0; i < imageData.length; i += 4) {
            const r = imageData[i];
            const g = imageData[i + 1];
            const b = imageData[i + 2];
            const brightness = 0.2126 * r + 0.7152 * g + 0.0722 * b; // Luminance formula
            totalBrightness += brightness;
          }
          const avgBrightness = totalBrightness / (width * height);
          // Set a threshold for low-light detection
          const lowLightThreshold = 30;
          if (avgBrightness < lowLightThreshold) {
            console.log('Face is in low light.');
            setLowLight(false);
            // setDetectionStarted(false);
            await messageApi.open({
              type: 'error',
              content: 'Please Ensure Adequate Lighting',
            });
          } else {
            console.log('Face is lighting is sufficient.');
            const imageString = videoRef.current.getScreenshot();
            const file = getFileFromBase64(
              imageString,
              'profile.jpeg',
              'image/jpeg',
            );
            setLiveSnap(file);
            sendSnap(file);
            setLowLight(true);
            // setDetectionStarted(false);
            setCapturedata(detection?.descriptor);
          }
        } else {
          setDetectionStarted(false);
        }
      }
    });
  };
  // const capture = () => {
  //   if (invalidCaptureConditions) return;
  //   setDetectionStarted(true);
  //   window.requestAnimationFrame(async () => {
  //     const detections = await tinyFaceDetector(
  //       videoRef.current.getCanvas(),
  //     );
  //     if (detections?.length > 1) {
  //       await messageApi.open({
  //         type: 'error',
  //         content: 'Multiface Detected',
  //       });
  //     } else {
  //       const imageString = videoRef.current.getScreenshot();
  //       const file = getFileFromBase64(
  //         imageString,
  //         'profile.jpeg',
  //         'image/jpeg',
  //       );
  //       setLiveSnap(file);
  //       sendSnap(file);

  //       // const detection = await faceapi
  //       //   .detectSingleFace(
  //       //     videoRef.current.getCanvas(),
  //       //     new faceapi.TinyFaceDetectorOptions({
  //       //       inputSize: 160,
  //       //       scoreThreshold: 0.5,
  //       //     }),
  //       //   )
  //       //   .withFaceLandmarks()
  //       //   .withFaceDescriptor();

  //       // if (detection) {
  //       //   setDetectionStarted(false);
  //       //   setCapturedata(detection.descriptor);
  //       // }

  //       // ------------------------------------>
  //       // // Detect face and extract embedding
  //       // setDetectionStarted(true)
  //       const detection = await faceapi
  //         .detectSingleFace(
  //           videoRef.current.getCanvas(),
  //           new faceapi.SsdMobilenetv1Options(),
  //         )
  //         .withFaceLandmarks()
  //         .withFaceDescriptor();
  //       if (detection) {
  //         setDetectionStarted(false);
  //         setCapturedata(detection?.descriptor);
  //       }
  //     }
  //   });
  // };

  // console.log('capturedFaceEmbeddingdetection', capturedFaceEmbedding);
  // const matchFace = async () => {
  //   if (!videoRef.current?.video || !capturedFaceEmbedding) return;
  //   const video = videoRef.current.video;
  //   const detection = await faceapi
  //     .detectSingleFace(video, new faceapi.SsdMobilenetv1Options())
  //     .withFaceLandmarks()
  //     .withFaceDescriptor();

  //   if (detection) {
  //     const distance = faceapi.euclideanDistance(
  //       detection.descriptor,
  //       capturedFaceEmbedding,
  //     );
  //     console.log('Matching Distance:', distance);

  //     if (distance < 0.6) {
  //       console.log('Face Matched!');
  //     } else {
  //       console.log('Face Not Matched.');
  //     }
  //   } else {
  //     console.error('No face detected in video.');
  //   }
  // };

  // useEffect(() => {
  //   console.log('ENTERED HERE');
  //   if (!capturedFaceEmbedding) return;
  //   const intervalId = setInterval(() => {
  //     matchFace();
  //   }, 1000);

  //   return () => clearInterval(intervalId);
  // }, [capturedFaceEmbedding]);

  console.log(
    isDetectionStarted,
    'isDetectionStartedisDetectionStarted',
    invalidCaptureConditions,
  );
  console.log(faceThreshold, 'faceThreshold');
  const content = (
    <div className={`text-[#FFF]`}>
      <p>{faceThreshold < 30 ? 'Poor Quality' : 'Good Quality'}</p>
    </div>
  );
  const backgroundColor = faceThreshold < 30 ? '#E94A47' : '#49A546';
  const buildWebLayout = () => {
    return (
      <>
        {contextHolder}
        {isWebStart ? (
          <div className="p-[30px] flex tab:flex-row flex-col-reverse items-center gap-5 min-h-screen w-full justify-center bg-white dark:bg-gray-950">
            <div className=" flex-col items-center justify-center  mt-[10px] flex tab:w-[40%] w-[80%]">
              <h1 className="test_count text-center text-[40px] font-bold text-[#000000] dark:text-white italic">
                You Look Smart & <br />
                Confident!
              </h1>
              <h4 className="test_count text-[22px] font-semibold text-[#000000] dark:text-white my-5">
                Your Interview Will Start In
              </h4>
              {startCount !== 'NaN' && startCount > 0 && (
                <div class="bg-cover w-[200px] h-[120px] flex items-center justify-center">
                  <h1 className="text-[50px] text-[#04D0C7] dark:text-dark-primaryMain font-sans font-bold">
                    <span>{startCount ? startCount : ''}</span>
                  </h1>
                </div>
              )}
            </div>
            <div className="camera_preview sm:h-[22rem] sm:w-[22rem] tab:h-[25rem] tab:w-[25rem] h-[20rem] w-[20rem]">
              <Webcam
                playsInline
                muted
                ref={videoRef}
                screenshotFormat="image/jpeg"
                audioConstraints={{
                  echoCancellation: true,
                  noiseSuppression: true,
                }}
                videoConstraints={{
                  width: 1280,
                  height: 720,
                  facingMode: { ideal: 'user' },
                }}
                className="m-auto sm:h-[22rem] sm:w-[22rem] tab:h-[25rem] tab:w-[25rem] h-[20rem] w-[20rem] rounded-full object-cover"
              />
            </div>
          </div>
        ) : (
          <div className="p-[30px] flex flex-col justify-center items-center w-full min-h-screen gap-5">
            <div className="flex items-center gap-5 justify-center w-full tab:flex-row flex-col flex-col-reverse">
              {!isWebStart && (
                <div className="testscreen_div tab:w-[40%] w-[80%] ">
                  <div className=" p-5 bg-white rounded-xl dark:bg-dark-secondaryBgMain">
                    <ul>
                      <li className="test_list_web ">
                        <h4>
                          {liveSnap !== undefined
                            ? 'Picture Captured for Future Reference.'
                            : 'Please click the Capture Button.'}
                        </h4>
                        <span>
                          <img
                            src={liveSnap !== undefined ? Right : Wrong}
                            alt=""
                          />
                        </span>
                      </li>
                      <li className="test_list_web">
                        <h4>Ensure Adequate Lighting</h4>
                        <span>
                          <img src={isLowLight ? Right : Wrong} alt="" />
                        </span>
                      </li>
                      <li className="test_list_web">
                        <h4>Minimum Bandwidth</h4>{' '}
                        <span>
                          <img
                            src={isNetSpeedGood ? Right : Wrong}
                            alt=""
                          />
                        </span>
                      </li>
                      <li className="test_list_web">
                        <h4>Accessible Mic and Camera</h4>
                        <span>
                          <img src={isMicGood ? Right : Wrong} alt="" />
                        </span>
                      </li>
                      {/* <li className="test_list_web">
                        <div className="w-[90%]">
                          <h4>Operating System</h4>
                          <p className="text-black dark:text-white">
                            {systemOS}
                          </p>
                        </div>
                        <span>
                          <img src={Right} alt="" />
                        </span>
                      </li> */}
                      <li className="test_list_web">
                        <div className="flex items-center gap-5 w-[90%]">
                          <span className="text-[15px] dark:text-white">
                            Device Check{' '}
                          </span>
                          <div
                            className="flex items-center gap-2 cursor-pointer"
                            onClick={() => {
                              stopWebcam();
                              setRecordingModalOpen(true);
                            }}
                          >
                            <span className="text-[#11B2AB] text-sm font-semibold">
                              Check Now
                            </span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="10"
                              viewBox="0 0 10 10"
                              fill="none"
                            >
                              <path
                                d="M0.792969 5.45239L7.79607 5.45239L4.57936 8.6691L5.39648 9.48047L10 4.87695L5.39648 0.273438L4.58511 1.08481L7.79607 4.30151L0.792969 4.30151V5.45239Z"
                                fill="#11B2AB"
                              />
                            </svg>
                          </div>
                        </div>
                        <span>
                          <img
                            src={isVideoStreamOK ? Right : Wrong}
                            alt=""
                          />
                        </span>
                      </li>
                    </ul>

                    {isDisabled() === false ? (
                      <>
                        <div className="flex justify-center mt-12">
                          <h1 className="ms:text-[24px] text-[20px] font-semibold text=[#000000] dark:text-[#426CFF]">
                            This system is good to go!
                          </h1>
                        </div>
                        {!isWebStart &&
                          (isDisabled() === false ? (
                            <div className="checkbox_div mt-11 tab:hidden flex justify-center">
                              <button
                                className={
                                  isDisabled()
                                    ? 'web_screen_button_disabled rounded-full ms:w-64 w-full'
                                    : 'web_screen_button rounded-full bg-[#11B2AB] dark:bg-dark-primaryMain web_screen_button_new ms:w-64 w-full'
                                }
                                style={{ float: 'right' }}
                                onClick={() => startWebInterview()}
                              >
                                Start Interview
                              </button>
                            </div>
                          ) : null)}
                      </>
                    ) : (
                      <div className="p-5 pt-5 w-full flex items-center justify-center mt-11">
                        <button
                          className="rounded-3xl border border-[#000] dark:border-[#426CFF] dark:text-[#426CFF] py-3 px-8 tab:w-[40%] w-full"
                          onClick={async () => await checkRequirements()}
                        >
                          Check Again
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* {isWebStart && (
                <div className=" flex-col items-center justify-center  mt-[10px] tab:hidden flex tab:w-[40%] w-[80%]">
                  <h1 className="test_count text-center text-[40px] font-bold text-[#000000]">
                    You Look Smart & <br />
                    Confident!
                  </h1>
                  <h4 className="test_count text-[22px] font-semibold text-[#000000] my-5">
                    Your Interview Will Start In
                  </h4>
                  <div class="bg-cover w-[200px] h-[120px] flex items-center justify-center">
                    <h1 className="text-[50px] text-[#04D0C7] font-sans ont-bold">
                      <span>{startCount ? startCount : ''}</span>
                    </h1>
                  </div>
                </div>
              )} */}

              <div
                className={`${isRecordingOpen ? 'hidden' : 'block'} bg-transparent ai_progress relative flex items-center flex-col tab:w-[40%] w-[80%]`}
              >
                <div className="camera_preview absolute sm:h-[25rem] sm:w-[25rem] h-[20rem] w-[20rem]">
                  <Webcam
                    muted
                    playsInline
                    ref={videoRef}
                    screenshotFormat="image/jpeg"
                    audioConstraints={{
                      echoCancellation: true,
                      noiseSuppression: true,
                    }}
                    videoConstraints={{
                      width: 1280,
                      height: 720,
                      facingMode: { ideal: 'user' },
                    }}
                    className="m-auto sm:h-[25rem] sm:w-[25rem] h-[20rem] w-[20rem] rounded-full object-cover"
                  />
                </div>
                {!isWebStart && !isRecordingOpen && (
                  <Popover
                    content={content}
                    open={true}
                    className="progress_tooltip"
                    overlayInnerStyle={{
                      background: backgroundColor,
                      padding: '5px',
                    }}
                    overlayClassName={`progress_tooltip ${backgroundColor === '#E94A47' ? 'arrow-red' : 'arrow-green'}`}
                  >
                    <Progress
                      percent={faceThreshold}
                      status="active"
                      strokeColor={progressColorType}
                      showInfo
                      type="circle"
                      className="relative"
                      strokeWidth="2"
                      format={() => {}}
                    />
                  </Popover>
                )}

                {!isWebStart && (
                  <div className="mt-4 flex flex-col justify-center items-center gap-4">
                    <p className="text-base font-normal text-black dark:text-white  tab-mt-0 mt-8">
                      Image Quality (Min. 30% needed)
                    </p>
                    <button
                      className={`${isDetectionStarted ? 'disabled:' : 'enabled'} py-2 px-6 rounded-full flex items-center gap-2 ${invalidCaptureConditions ? (isDarkMode ? 'bg-dark-secondaryBgMain' : 'bg-[#BFBFBF]') : isDarkMode ? 'bg-dark-primaryMain' : 'bg-[#11B2AB]'}`}
                      onClick={() => capture()}
                    >
                      <img src={Camera} />
                      <span className="text-[#fff]">
                        {isDetectionStarted ? 'Capturing' : 'Capture'}
                      </span>
                    </button>
                  </div>
                )}
                {!isWebStart && (
                  <div className="mt-4 flex flex-col justify-center items-center gap-4 w-full absolute bottom-[160px]">
                    {multipleFacesDetected && (
                      <div className="p-2 text-base font-medium bg-[#FFDB96] rounded-full border border-[#795B23] px-3 py-1 text-[#795B23]">
                        Multiple Faces Detected
                      </div>
                    )}
                    {faces?.length < 1 && (
                      <div className="p-2 text-base font-medium bg-[#FFDB96] rounded-full border border-[#795B23] px-3 py-1 text-[#795B23]">
                        No Faces Detected
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div>
              {!isWebStart &&
                (isDisabled() === false ? (
                  <div className="checkbox_div tab:flex hidden justify-center">
                    <button
                      className={
                        isDisabled()
                          ? 'web_screen_button_disabled rounded-full ms:w-64 w-full'
                          : 'web_screen_button rounded-full bg-[#11B2AB] dark:bg-dark-primaryMain web_screen_button_new ms:w-64 w-full'
                      }
                      style={{ float: 'right' }}
                      onClick={() => startWebInterview()}
                    >
                      Start Interview
                    </button>
                  </div>
                ) : null)}
            </div>
          </div>
        )}
        {isRecordingOpen && (
          <Modal
            title="Device Check"
            open={isRecordingOpen}
            onCancel={() => setRecordingModalOpen(false)}
            // header={null}
            footer={null}
            // closable={false}
            // title={<div className='w-full text-center text-4xl font-semibold'>Recording Test</div>}
            width={600}
          >
            <AITestRecording
              // videoRef={videoRef}
              setVideoStreamTest={setVideoStreamTest}
              setRecordingModalOpen={setRecordingModalOpen}
            />
          </Modal>
        )}
      </>
    );
  };

  // return <>{isMobileDevice ? buildMobileLayout() : buildWebLayout()}</>;
  return <>{buildWebLayout()}</>;
};
export default AITestScreen;
